import { render, staticRenderFns } from "./SettingsGroups.vue?vue&type=template&id=41a20a95"
import script from "./SettingsGroups.vue?vue&type=script&lang=js"
export * from "./SettingsGroups.vue?vue&type=script&lang=js"
import style0 from "./SettingsGroups.vue?vue&type=style&index=0&id=41a20a95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports